import { TextField } from '@statsbomb/kitbag-components';
import PropTypes from 'prop-types';
import React from 'react';
import { useIntl } from 'react-intl';
import { MatchPart as MatchPartSelection } from '../MetadataSelection/MatchPart';
import { Sport as SportSelection } from '../MetadataSelection/Sport';
import { Track as TrackSelection } from '../MetadataSelection/Track';
import { Version as VersionSelection } from '../MetadataSelection/Version';
import SelectMatchId from '../SelectMatchId';

export function Timestamp({
  disabled,
  label,
  labelPosition,
  setTimestamp,
  size,
  timestamp,
  readOnly,
}) {
  const intl = useIntl();
  const defaultLabel = intl.formatMessage({
    defaultMessage: 'Timestamp',
    description: 'Timestamp',
    id: '45458',
  });

  return (
    <TextField
      id={`metadata-timestamp-${label?.replace(' ', '-')}`}
      isDisabled={disabled}
      label={label || defaultLabel}
      labelPosition={labelPosition}
      onChange={(event) => setTimestamp(event.target.value)}
      placeholder="hh:mm:ss"
      size={size}
      value={timestamp}
      variant="secondary"
      readOnly={readOnly}
    />
  );
}

Timestamp.propTypes = {
  disabled: PropTypes.bool,
  label: PropTypes.string,
  labelPosition: PropTypes.string,
  readOnly: PropTypes.bool,
  setTimestamp: PropTypes.func,
  size: PropTypes.string,
  timestamp: PropTypes.string,
};
Timestamp.defaultProps = {
  disabled: false,
  label: undefined,
  labelPosition: 'left',
  readOnly: true,
  setTimestamp: () => {},
  size: undefined,
  timestamp: undefined,
};

export const MetadataSelections = {
  MatchId: SelectMatchId,
  MatchPart: MatchPartSelection,
  Sport: SportSelection,
  Timestamp,
  Track: TrackSelection,
  Version: VersionSelection,
};

export default MetadataSelections;
